/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Aveda {
    angular.module("meevo.plugins.aveda", []);
}